import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=131e7a56&scoped=true&lang=html&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e7a56",
  null
  
)

export default component.exports